import { Component, input, output } from '@angular/core';
import {
  IconComponent,
  cueFinish,
  cueNavigation,
  cueElevator,
  cueDirectionLeft,
  cueDirectionSharpLeft,
  cueDirectionSlightLeft,
  cueDirectionRight,
  cueDirectionSharpRight,
  cueDirectionSlightRight,
  cueDirectionStraight,
  cueIcon,
  cueMarker,
  cueMap,
} from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { AngleDirectionEnum, InstructionItem } from '@cue/data';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'assist-directions-item-renew',
  templateUrl: './directions-item-renew.component.html',
  styleUrls: ['./directions-item-renew.component.scss'],
  imports: [IconComponent, DecimalPipe],
})
export class DirectionsItemRenewComponent {
  ICONS = {
    cueFinish,
    cueNavigation,
    cueElevator,
    cueDirectionStraight,
    cueDirectionLeft,
    cueDirectionSharpLeft,
    cueDirectionSlightLeft,
    cueDirectionRight,
    cueDirectionSharpRight,
    cueDirectionSlightRight,
    cueMarker,
    cueMap,
  };
  translation = translation;
  toNextArea = output<number>();
  buttonClicked = output<MouseEvent>();
  selected = input(false);
  lastStepShouldBeRestart = input(false);
  direction = input<InstructionItem>();
  routeNoteNumber = input<number | null>(null);

  getArrowIcon(directionAngle: AngleDirectionEnum): cueIcon {
    switch (directionAngle) {
      case AngleDirectionEnum.Straight:
        return this.ICONS.cueDirectionStraight;
      case AngleDirectionEnum.SuperLowLeft:
      case AngleDirectionEnum.LowLeft:
        return this.ICONS.cueDirectionSlightLeft;
      case AngleDirectionEnum.Left:
        return this.ICONS.cueDirectionLeft;
      case AngleDirectionEnum.SuperLeft:
        return this.ICONS.cueDirectionSharpLeft;
      case AngleDirectionEnum.SuperLowRight:
      case AngleDirectionEnum.LowRight:
        return this.ICONS.cueDirectionSlightRight;
      case AngleDirectionEnum.Right:
        return this.ICONS.cueDirectionRight;
      case AngleDirectionEnum.SuperRight:
        return this.ICONS.cueDirectionSharpRight;
      default:
        return this.ICONS.cueDirectionStraight;
    }
  }

  goToNextArea(event: MouseEvent) {
    this.toNextArea.emit(this.direction().areaId);
    event.stopPropagation();
  }

  highlightRoute(event: MouseEvent) {
    this.buttonClicked.emit(event);
  }
}
